import React, { useState } from 'react';
import { businessPlanConfig } from '../../commons/config';
import businessPlanFeatureImage from '../../assets/images/business-plan-feature.png';
import { DownloadOnAppStoreBanner } from '../../help/components/DownloadOnAppStoreBanner';
import { GetItOnGooglePlayBanner } from '../../help/components/GetItOnGooglePlayBanner';
import MobileAppFeatureImage from '../../assets/images/mobile-app-feature.png';
import { ReleasePromptData } from '../types';
import { useIsSmallerThanDesktop } from '../../responsive/hooks/hooks';
import { openUrlInNewTab } from '../../util/window-utils';
import {
  APP_STORE_APP_URL,
  DownloadAppModal,
  GOOGLE_PLAY_APP_URL,
} from '../../help/components/DownloadAppModal';
import { v4 as uuidv4 } from 'uuid';

const BusinessPlanReleaseContent = () => (
  <div className="release-prompt__content-container">
    <img src={businessPlanFeatureImage} alt="Business plan" />
    <div>
      <div>
        Easily create a professional business plan to help secure funding for your small business.
        <br />
        Try our new AI-powered feature today!
      </div>
    </div>
  </div>
);

const MobileAppReleaseContent = () => {
  const isSmallerThanDesktop = useIsSmallerThanDesktop();
  const [downloadOnAppStoreKey, setDownloadOnAppStoreKey] = useState<string | null>(null);
  const [getOnPlayStoreKey, setGetOnPlayStoreKey] = useState<string | null>(null);

  return (
    <div className="release-prompt__content-container">
      <img src={MobileAppFeatureImage} alt="Mobile app" width={300} />
      <div
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '24px' }}
      >
        <DownloadOnAppStoreBanner
          onClick={() => {
            if (isSmallerThanDesktop) {
              openUrlInNewTab(APP_STORE_APP_URL);
            } else {
              setDownloadOnAppStoreKey(uuidv4());
            }
          }}
          large={true}
        />
        <GetItOnGooglePlayBanner
          onClick={() => {
            if (isSmallerThanDesktop) {
              openUrlInNewTab(GOOGLE_PLAY_APP_URL);
            } else {
              setGetOnPlayStoreKey(uuidv4());
            }
          }}
          large={true}
        />
      </div>
      {downloadOnAppStoreKey && <DownloadAppModal store="app-store" key={downloadOnAppStoreKey} />}
      {getOnPlayStoreKey && <DownloadAppModal store="play-store" key={getOnPlayStoreKey} />}
    </div>
  );
};

export const RELEASE_PROMPTS: ReleasePromptData[] = [
  {
    route: '/business-plan',
    content: <BusinessPlanReleaseContent />,
    enabled: businessPlanConfig.enabled,
    expiration: new Date('2025-03-01'),
    title: 'Our AI-Driven Business Plan Builder is Live!',
    promptId: 1,
    code: 'business-plan',
  },
  {
    content: <MobileAppReleaseContent />,
    enabled: true,
    expiration: new Date('2025-04-01'),
    title: 'Growegy mobile app for Android and iOS is now available for download!',
    promptId: 2,
    code: 'mobile-app',
    skipMobile: true,
  },
];
